module.exports = __webpack_public_path__ + "img/groupbuy.10ad8155.png";